import React from 'react'
import { useChannelContext } from './Context'
import { BaseLayout } from '../Chat/BaseLayout'

export const Layout = () => {
  const { components, ...context } = useChannelContext()

  return <BaseLayout components={components} {...context} />
}
